import { render, staticRenderFns } from "./sidebar copy.vue?vue&type=template&id=50cdf130&scoped=true"
import script from "./sidebar copy.vue?vue&type=script&lang=js"
export * from "./sidebar copy.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=50cdf130&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cdf130",
  null
  
)

export default component.exports